const API = process.env.REACT_APP_BACKEND_URL;
const CHUNK = 5 * 1024 * 1024;

export async function uploadFile(file, onProgress) {
  if (file.size <= CHUNK * 2) {
    onProgress?.(10);
    const fd = new FormData();
    fd.append("file", file);
    const r = await fetch(`${API}/api/admin/upload`, { method: "POST", credentials: "include", body: fd });
    if (!r.ok) throw new Error("Upload failed");
    onProgress?.(100);
    return (await r.json()).href;
  }
  const init = await fetch(`${API}/api/admin/upload/init`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ filename: file.name, content_type: file.type || "application/octet-stream" }),
  });
  if (!init.ok) throw new Error("Upload init failed");
  const { upload_id } = await init.json();
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
    fd.append("index", String(i));
    const r = await fetch(`${API}/api/admin/upload/chunk/${upload_id}`, { method: "POST", credentials: "include", body: fd });
    if (!r.ok) throw new Error("Chunk upload failed");
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const done = await fetch(`${API}/api/admin/upload/complete/${upload_id}`, { method: "POST", credentials: "include" });
  if (!done.ok) throw new Error("Upload finalize failed");
  onProgress?.(100);
  return (await done.json()).href;
}
